import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class SnackBarService {
    private snackBarSubject = new Subject<any>();
    public snackBarState = this.snackBarSubject.asObservable();

    constructor() {}

    show(message: string, type: string = "INFO", timout: number = 10000) {
        this.snackBarSubject.next({
            show: true, message, type, timout
        });
    }
}
